import React, { useEffect, useState } from 'react';
import {
  confirmInvite,
  confirmInviteStatusRequest
} from '../services/auth.service';
import { Link, useNavigate } from 'react-router-dom';
import { getUrlParams } from '../services/parameter.service';
import Button from '../components/Button';
import LoadingSpinner from '../components/LoadingSpinner';
import Feedback from '../components/Feedback';

const ConfirmInvite: React.FC = () => {
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [successful, setIsSuccessful] = useState(false);

  const [errors, setErrors] = useState([] as string[]);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const { userId, code, forwardUrl } = getUrlParams();

  const navigate = useNavigate();

  const handle = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setLoading(true);

    try {
      const result = await confirmInvite(
        userId,
        code,
        firstName,
        lastName,
        password,
        confirmPassword
      );
      if (result.success) {
        setIsSuccessful(true);
      } else {
        setErrors(result.errors);
        return false;
      }
    } finally {
      setLoading(false);
    }
  };

  const getData = async () => {
    const response = await confirmInviteStatusRequest(userId, code);

    if (response.success) {
      setPageLoading(false);
      return;
    }

    if (forwardUrl) {
      navigate(`/Account/Login?forwardUrl=${forwardUrl}`);
    } else {
      navigate(`/Account/Login`);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (pageLoading) {
    return <LoadingSpinner />;
  }

  if (successful) {
    return (
      <div>
        <div>
          Invite confirmed. Please{' '}
          <Link
            to={
              forwardUrl
                ? `/Account/Login?forwardUrl=${forwardUrl}`
                : '/Account/Login'
            }
          >
            log in
          </Link>
          .
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handle} className="content-form">
      <div className="field">
        <label htmlFor="firstName">First Name</label>
        <input
          id="firstName"
          type="text"
          placeholder="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </div>
      <div className="field">
        <label htmlFor="lastName">Last Name</label>
        <input
          id="lastName"
          type="text"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </div>
      <div className="field">
        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          placeholder="Password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div className="field">
        <label htmlFor="confirmPassword">Confirm Password</label>
        <input
          id="confirmPassword"
          type="password"
          placeholder="Confirm Password"
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </div>
      <div className="button-container">
        <Button className="action-button" isLoading={loading} isSubmit={true}>
          Join
        </Button>
      </div>
      <Feedback messages={errors} type="error" />
    </form>
  );
};

export default ConfirmInvite;
